import { Component } from '@angular/core';
import { ChildrenOutletContexts, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { slideInAnimation } from 'src/shared/animations/animations';
import { LogoutComponent } from '@app-logout/feature/logout.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonicModule, RouterModule, LogoutComponent],
  animations: [slideInAnimation],
})
export class AppComponent {

  constructor(private contexts: ChildrenOutletContexts) { }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }
}
